let links: LinkedListInstance[] = [];

function __add__(link: LinkedListInstance): void {
    links.push(link);
}

function __clear__() {
    links.length = 0;
}

function __walk__(callback: (...args) => void): void {
    links.forEach((link: LinkedListInstance, index: number): void => {
        callback(link, index);
    });
}

function __length__(): number {
    return links.length;
}

function __replaceAll__(links: LinkedListInstance[]): void {
    __clear__();
    links.forEach((link: LinkedListInstance): void => {
        __add__(link);
    });
}

function __getLinks__(): LinkedListInstance[] {
    return links.map((link: LinkedListInstance) => {
        return link;
    });
}

function __clearShortLink__(): void {
    for (let i = 0; i < links.length; i++) {
        if (links[i].length === 1) {
            links.splice(i, 1);
            i--;
        }
    }
}

export {
    __add__,
    __clear__,
    __walk__,
    __length__,
    __replaceAll__,
    __clearShortLink__,
    __getLinks__
};
